import React, { useEffect, useState } from 'react';
import Modal from '../../UI/Modal';
import Button from '../../UI/Button';
import Input from '../../UI/Input';
import './StockEditModal.css';

const StockEditModal = ({
  isOpen,
  onClose,
  product,
  onSave,
  loading = false
}) => {
  const [quantity, setQuantity] = useState('');

  const variant = product?.variants?.[0];
  const trackingOn = Boolean(variant?.inventory_management);
  const currentQty = variant?.inventory_quantity;

  useEffect(() => {
    if (product && isOpen) {
      setQuantity(
        currentQty == null || Number.isNaN(Number(currentQty))
          ? ''
          : String(currentQty)
      );
    }
  }, [product, isOpen, currentQty]);

  const handleClose = () => {
    setQuantity('');
    onClose();
  };

  const handleSave = () => {
    const parsed = Number(quantity);
    if (!Number.isInteger(parsed) || parsed < 0) return;
    onSave(parsed);
  };

  const parsedQty = Number(quantity);
  const canSave =
    trackingOn &&
    Number.isInteger(parsedQty) &&
    parsedQty >= 0 &&
    parsedQty !== Number(currentQty);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Stok Düzenle"
      size="md"
    >
      <div className="stock-edit-form">
        <p className="stock-edit-title">{product?.title}</p>

        <Input
          label="Stok adedi"
          type="text"
          inputMode="numeric"
          value={quantity}
          onChange={(e) => setQuantity(e.target.value.replace(/\D/g, ''))}
          placeholder=""
          disabled={!trackingOn || loading}
          autoFocus
          autoComplete="off"
        />

        {trackingOn ? (
          <p className="stock-edit-hint">
            Mevcut stok: {currentQty == null ? '—' : currentQty}
          </p>
        ) : (
          <p className="stock-edit-warning">
            Bu üründe stok takibi kapalı. Shopify’da ürünü açın → Envanter →
            Miktarı izle.
          </p>
        )}

        <div className="modal-actions">
          <Button
            variant="success"
            onClick={handleSave}
            loading={loading}
            disabled={!canSave || loading}
          >
            {loading ? 'Kaydediliyor...' : 'Kaydet'}
          </Button>
          <Button
            variant="secondary"
            onClick={handleClose}
            disabled={loading}
          >
            İptal
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default StockEditModal;
